<template>
  <div
    id="box"
    :style="[
      $vuetify.breakpoint.xs
        ? { 'border-radius': '5px 5px 5px 5px', width: '15rem' }
        : { 'border-radius': '0 5px 5px 0', width: '30rem' },
    ]"
  >
    <div v-if="chat">
      <div
        id="header"
        :style="[
          $vuetify.breakpoint.xs
            ? { 'border-radius': '5px 5px 0px 0px', width: '15rem' }
            : { 'border-radius': '0 5px 0 0', width: '30rem' },
        ]"
      >
        <b-icon-arrow-left
          @click="$emit('back')"
          v-if="$vuetify.breakpoint.xs"
          font-scale="1.3"
          class="mr-3"
        ></b-icon-arrow-left>
        <img
          style="border-radius: 50px; object-fit: cover"
          width="40"
          height="40"
          :src="
            chat.userData[
              chat.members.find((item) => item != userProfile.email)
            ].profilePicUrl
          "
        />
        <div class="chat-deets">
          <span style="font-size: 11pt; margin-left: 10px">
            <b>{{
              chat.userData[
                chat.members.find((item) => item != userProfile.email)
              ].name
            }}</b>
          </span>
        </div>
      </div>
      <div
        id="message-box"
        ref="messageBox"
        :style="[
          $vuetify.breakpoint.xs ? { width: '15rem' } : { width: '30rem' },
        ]"
      >
        <div
          class="message-container"
          v-for="message in messages"
          :key="message.timestamp"
        >
          <div
            class="message"
            :class="[
              message.sender == userProfile.email
                ? 'my-message'
                : 'other-message',
            ]"
            :style="[
              $vuetify.breakpoint.xs
                ? { 'margin-left': '1rem', 'margin-right': '1rem' }
                : {},
            ]"
          >
            {{ message.message }}
          </div>
          <div
            class="meta"
            :style="[
              message.sender == userProfile.email
                ? { 'flex-direction': 'row-reverse' }
                : { 'flex-direction': 'row' },
            ]"
          >
            <img
              :src="chat.userData[message.sender].profilePicUrl"
              width="30"
              height="30"
              style="border-radius: 50px; object-fit: cover"
            />
            <span style="color: gray; font-size: 9pt; margin: 0px 7px">{{
              message.timestamp | fromNow
            }}</span>
          </div>
        </div>
      </div>
      <div
        id="input-box"
        :style="[
          $vuetify.breakpoint.xs
            ? { 'border-radius': '0px 0px 5px 5px', width: '15rem' }
            : { 'border-radius': '0 0 5px 0', width: '30rem' },
        ]"
      >
        <textarea
          v-model="input"
          @keydown.enter="sendByEnter($event)"
          id="msg-input"
          resizeable="false"
          :style="[$vuetify.breakpoint.xs ? {} : { width: '24rem' }]"
          placeholder="Enter your message here"
        />
        <v-icon @click="send()">mdi-send</v-icon>
      </div>
    </div>
    <div v-else id="placeholder">
      <v-icon color="#ffdab9" size="50px">mdi-chat</v-icon>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
const fb = require("../../firebaseConfig");
import moment from "moment";

export default {
  data() {
    return {
      input: "",
      messages: [],
      last: null,
      unsubscribe: null,
    };
  },
  props: {
    chat: {
      type: Object,
    },
  },
  watch: {
    chat: {
      immediate: true,
      handler(newVal) {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
        if (newVal) {
          this.messages = [];
          const msgQuery = fb.db
            .collection("chats")
            .doc(newVal.id)
            .collection("messages")
            .orderBy("timestamp", "desc");
          msgQuery
            .limit(12)
            .get()
            .then((qs) => {
              this.last = qs.docs[qs.docs.length - 1];
              qs.forEach((doc) => {
                this.messages.push(doc.data());
              });
              this.messages.splice(0, 1);
            });
          this.unsubscribe = msgQuery.limit(1).onSnapshot((qs) => {
            qs.docChanges().forEach((change) => {
              if (change.type == "added") {
                if (change.doc.data().sender != this.userProfile.email) {
                  fb.db.collection("chats").doc(this.chat.id).update({
                    recipientRead: true,
                  });
                }
                this.messages.unshift(change.doc.data());
              }
            });
          });
        }
      },
    },
  },
  computed: {
    ...mapState(["userProfile"]),
  },
  created() {
    this.debouncedScroll = debounce(this.getMore, 100);
  },
  updated() {
    const messageBox = document.getElementById("message-box");
    if (messageBox) {
      messageBox.addEventListener("scroll", () => {
        this.debouncedScroll();
      });
    }
  },
  mounted: function () {},
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    getMore(scroll) {
      const messageBox = document.getElementById("message-box");
      if (messageBox.scrollTop == 0) {
        fb.db
          .collection("chats")
          .doc(this.chat.id)
          .collection("messages")
          .orderBy("timestamp", "desc")
          .startAfter(this.last)
          .limit(12)
          .get()
          .then((qs) => {
            if (!qs.empty) {
              this.last = qs.docs[qs.docs.length - 1];
              qs.forEach((doc) => {
                this.messages.push(doc.data());
              });
            }
          });
      }
    },
    sendByEnter(e) {
      if (!e.shiftKey) {
        e.preventDefault();
        this.send();
      }
    },
    send() {
      if (this.input) {
        const message = this.input;
        this.input = "";
        fb.db
          .collection("chats")
          .doc(this.chat.id)
          .collection("messages")
          .add({
            timestamp: Date.now(),
            message,
            sender: this.userProfile.email,
          })
          .then(() => {
            fb.db.collection("chats").doc(this.chat.id).set(
              {
                lastMessage: message,
                lastSender: this.userProfile.email,
                chatUpdated: Date.now(),
                recipientRead: false,
              },
              {
                merge: true,
              }
            );
          });
      }
    },
  },
  filters: {
    fromNow(v) {
      return moment(v).fromNow();
    },
  },
};
</script>

<style scoped>
#box {
  height: 40rem;
  background: papayawhip;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
#header {
  height: 3.5rem;
  background: #ffdead;
  display: flex;
  align-items: center;
  padding: 0 15px;
  /* border-bottom: solid 1px peachpuff; */
}
#placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 40rem;
}
#message-box {
  height: 30rem;
  padding: 2rem;
  display: flex;
  flex-direction: column-reverse;
  overflow: scroll;
}
#input-box {
  /* border-top: solid 1px peachpuff; */
  height: 6.5rem;
  background-color: #ffdead;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
#msg-input {
  background-color: #fefefe;
  border-radius: 5px;
  font-size: 11pt;
  padding: 4px 8px;
  resize: none;
  height: 4rem;
}
.message {
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  margin-bottom: 0px;
  margin-top: 1rem;
  width: 85%;
  position: relative;
}
.message:after {
  bottom: 0;
  left: 10%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-top-color: #86bb71;
  border-bottom: 0;
  border-width: 8px;
  margin-left: -10px;
  margin-bottom: -8px;
}

.other-message {
  background-color: #86bb71;
}
.other-message:after {
  border-left: 0;
}
.my-message {
  background: #94c2ed;
  margin-left: auto;
}
.my-message:after {
  border-top-color: #94c2ed;
  left: 93%;
  border-right: 0;
}
.meta {
  display: flex;
  margin-top: 1rem;
  align-items: center;
}
</style>